import FingerprintJS from "@fingerprintjs/fingerprintjs";
import { dntEnabled, gpcEnabled } from "./privacy.js";

export interface FingerprintHandle {
  /** Resolved visitorId, or undefined if not yet ready / errored. */
  value: string | undefined;
  /** Resolves once FP loads. Never rejects (errors swallowed). */
  ready: Promise<string | undefined>;
}

/**
 * Non-blocking FingerprintJS load. Callers should snapshot `handle.value`
 * at event-build time; early events ship without `device_fp` and later
 * events include it once it resolves.
 */
export function loadFingerprint(): FingerprintHandle {
  const handle: FingerprintHandle = {
    value: undefined,
    ready: Promise.resolve(undefined),
  };

  if (gpcEnabled() || dntEnabled()) {
    return handle;
  }

  handle.ready = (async (): Promise<string | undefined> => {
    try {
      const agent = await FingerprintJS.load();
      const result = await agent.get();
      handle.value = result.visitorId;
      return result.visitorId;
    } catch {
      // FP is best-effort. Never block or break the page.
      return undefined;
    }
  })();

  return handle;
}
